import ApplicationReports from "./ApplicationReports";

const ApprovedApplications = () => {
  return(
    <ApplicationReports status="4" title="Accepted/Certificate Applications Report" heading="Accepted/Certificate Applications"></ApplicationReports>
  )
};

export default ApprovedApplications;
